var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("銷售應用中心")]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'OrderList'
      }
    }
  }, [_vm._v(" 訂單管理 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" 批次上傳 ")])], 1)], 1)])]), _c('b-card', [_vm.canSwitchMode ? _c('b-button-group', {
    staticClass: "d-flex"
  }, [_c('b-button', {
    staticClass: "flex-fill",
    attrs: {
      "variant": _vm.mode === 'simple' ? 'info' : 'secondary'
    },
    on: {
      "click": function click($event) {
        _vm.mode = 'simple';
      }
    }
  }, [_vm._v(" 精簡 ")]), _c('b-button', {
    staticClass: "flex-fill",
    attrs: {
      "variant": _vm.mode === 'simple' ? 'secondary' : 'info'
    },
    on: {
      "click": function click($event) {
        _vm.mode = 'standard';
      }
    }
  }, [_vm._v(" 標準 ")])], 1) : _vm._e(), _c('div', {
    staticClass: "col-12 col-xl-6 d-flex align-items-center"
  }, [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v(" 批次上傳-" + _vm._s(_vm.mode === 'simple' ? '精簡' : '標準') + " ")]), _c('span', {
    staticClass: "mdi mdi-help-circle-outline",
    attrs: {
      "id": "title"
    }
  }), _c('b-tooltip', {
    attrs: {
      "target": "title",
      "triggers": "hover"
    }
  }, [_vm._v(" 點擊上方，可切換上傳訂單『精簡或標準版』 ")])], 1), _c('div', {
    staticClass: "row my-3"
  }, [_c('div', {
    staticClass: "col-6 col-xl-6"
  }, [_c('div', {
    staticClass: "upload-workflow p-3 p-xl-4"
  }, [_c('div', {
    staticClass: "step-block"
  }, [_c('div', {
    staticClass: "step-title"
  }, [_vm._v("Step 1. 請選擇通路")]), _c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.isFetchMerchants
    },
    model: {
      value: _vm.selectedMerchantID,
      callback: function callback($$v) {
        _vm.selectedMerchantID = $$v;
      },
      expression: "selectedMerchantID"
    }
  }), _c('b-form-checkbox', {
    staticClass: "mt-2",
    model: {
      value: _vm.autoGenerateMember,
      callback: function callback($$v) {
        _vm.autoGenerateMember = $$v;
      },
      expression: "autoGenerateMember"
    }
  }, [_c('span', {
    staticClass: "d-inline-flex align-items-center text-danger"
  }, [_vm._v(" 自動建立會員編號 ")]), _c('span', {
    staticClass: "mdi mdi-information-outline ml-1 text-muted",
    attrs: {
      "id": "autoGenerateMemberTip"
    }
  })]), _c('b-tooltip', {
    attrs: {
      "target": "autoGenerateMemberTip",
      "triggers": "hover"
    }
  }, [_vm._v(" 只要會員編號或手機號碼其中一項有值，系統即會自動建立對應的 customer 資料。 ")])], 1), _c('div', {
    staticClass: "step-block"
  }, [_c('div', {
    staticClass: "step-title"
  }, [_vm._v("Step 2. 下載範例與選擇檔案")]), _c('div', {
    staticClass: "d-flex flex-wrap align-items-center step2-top-row"
  }, [_c('b-form-file', {
    key: _vm.fileInputKey,
    attrs: {
      "id": "fileInput",
      "plain": "",
      "hidden": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "change": _vm.handleUploadFile
    }
  }), _c('b-button', {
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "primary",
      "tag": "label",
      "for": "fileInput"
    }
  }, [_vm._v(" 請選擇檔案 ")]), _c('div', {
    staticClass: "selected-file-card ml-2"
  }, [_c('span', {
    staticClass: "selected-file-text text-truncate d-inline-block"
  }, [_vm._v(" " + _vm._s(_vm.selectedFileName ? "\u5DF2\u9078\u64C7\uFF1A".concat(_vm.selectedFileName) : "尚未選擇檔案") + " ")])])], 1), _c('div', {
    staticClass: "mt-2"
  }, [_vm.mode === 'simple' ? _c('a', {
    staticClass: "sample-file-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.getSampleExcelFile(_vm.getModuleConfig('order', 'sample_file.order_import_light_xls'), '/excel/order_simple_list.xlsx');
      }
    }
  }, [_vm._v(" 下載範例檔案 ")]) : _vm._e(), _vm.mode === 'standard' ? _c('a', {
    staticClass: "sample-file-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.getSampleExcelFile(_vm.getModuleConfig('order', 'sample_file.order_import_xls'), '/excel/order_standard_list.xlsx');
      }
    }
  }, [_vm._v(" 下載範例檔案 ")]) : _vm._e()])]), _c('div', {
    staticClass: "step-block mb-0"
  }, [_c('div', {
    staticClass: "step-title"
  }, [_vm._v("Step 3. 確認上傳")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": !_vm.form.file || !_vm.selectedMerchantID || _vm.isLoading
    },
    on: {
      "click": _vm.handleSubmitFile
    }
  }, [_vm._v(" 確定上傳 ")]), _vm.results.failed.length > 0 ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.exportFailedOrders
    }
  }, [_vm._v(" 下載失敗檔案（" + _vm._s(_vm.results.failed.length) + "） ")]) : _vm._e()], 1)])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "accordion",
    attrs: {
      "role": "tablist"
    }
  }, _vm._l(Object.keys(_vm.results), function (key, index) {
    return _c('b-card', {
      key: index,
      staticClass: "mb-1",
      attrs: {
        "no-body": ""
      }
    }, [_c('b-card-header', {
      staticClass: "p-1",
      attrs: {
        "header-tag": "header",
        "role": "tab"
      }
    }, [key === 'failed' ? _c('b-button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle.accordion-0",
        modifiers: {
          "accordion-0": true
        }
      }],
      attrs: {
        "block": "",
        "variant": "danger"
      }
    }, [_vm._v("失敗：" + _vm._s(_vm.results.failed.length) + "筆")]) : _vm._e(), key === 'createOrder' ? _c('b-button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle.accordion-1",
        modifiers: {
          "accordion-1": true
        }
      }],
      attrs: {
        "block": "",
        "variant": "info"
      }
    }, [_vm._v("新增訂單資料：" + _vm._s(_vm.results.createOrder.length) + "筆")]) : _vm._e(), key === 'createOrderItem' ? _c('b-button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle.accordion-2",
        modifiers: {
          "accordion-2": true
        }
      }],
      attrs: {
        "block": "",
        "variant": "info"
      }
    }, [_vm._v("新增訂單明細：" + _vm._s(_vm.results.createOrderItem.length) + "筆")]) : _vm._e(), key === 'updateOrder' ? _c('b-button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle.accordion-3",
        modifiers: {
          "accordion-3": true
        }
      }],
      attrs: {
        "block": "",
        "variant": "info"
      }
    }, [_vm._v("更新訂單資料：" + _vm._s(_vm.results.updateOrder.length) + "筆")]) : _vm._e(), key === 'updateOrderItem' ? _c('b-button', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle.accordion-4",
        modifiers: {
          "accordion-4": true
        }
      }],
      attrs: {
        "block": "",
        "variant": "info"
      }
    }, [_vm._v("更新訂單明細：" + _vm._s(_vm.results.updateOrderItem.length) + "筆")]) : _vm._e()], 1), _c('b-collapse', {
      attrs: {
        "id": "accordion-".concat(index),
        "visible": "",
        "accordion": "my-accordion",
        "role": "tabpanel"
      }
    }, [_c('b-card-body', [_c('b-table', {
      attrs: {
        "striped": "",
        "hover": "",
        "responsive": "",
        "items": _vm.results[key],
        "fields": _vm.tableFields(key),
        "busy": _vm.isLoading
      },
      scopedSlots: _vm._u([{
        key: "table-busy",
        fn: function fn() {
          return [_c('div', {
            staticClass: "text-center my-2"
          }, [_c('b-spinner', {
            staticClass: "align-middle"
          })], 1)];
        },
        proxy: true
      }], null, true)
    })], 1)], 1)], 1);
  }), 1)])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }